<template>
  <div class="card-button">
    <v-btn fab outline :color="color" @click="click">
      <v-icon>{{icon}}</v-icon>
    </v-btn>
    <div>
      <span>{{text}}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'button-card',
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    icon: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: 'Button'
    },
    onClick: {
      type: Function,
      default: _ => console.log('onClick')
    }
  },
  methods: {
    click () {
      this.onClick();
    }
  }
};
</script>

<style scoped>
.card-button {
  text-align: center;
  margin-top: 16px;
}
.card-button >>> .v-btn .v-icon{
  height: initial;
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/card/buttoncard.vue